import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'

import {
  type GalleryItemKind,
  buildReviewClickTrackingPayload,
  buildScrollEndTrackingPayload,
  buildScrollStartTrackingPayload,
  buildSlideImpressionTrackingPayload,
  buildVideoCompleteTrackingPayload,
  buildVideoPlayTrackingPayload,
} from './utils/scrollTracking.utils'

export function useGalleryTracking(trackingProductModel: string) {
  const { trackClick, trackCarouselImpression, trackVideoImpression } =
    useTracking()

  function onScrollStart() {
    trackClick(buildScrollStartTrackingPayload(trackingProductModel))
  }

  function onScrollEnd() {
    trackClick(buildScrollEndTrackingPayload(trackingProductModel))
  }

  function onSlideImpression({
    currentSlide,
    totalSlides,
    itemKind,
  }: {
    currentSlide: number
    totalSlides: number
    itemKind: GalleryItemKind
  }) {
    trackCarouselImpression(
      buildSlideImpressionTrackingPayload({
        currentSlide,
        totalSlides,
        itemKind,
      }),
    )
  }

  function onVideoPlay() {
    trackVideoImpression(buildVideoPlayTrackingPayload(trackingProductModel))
  }

  function onVideoComplete() {
    trackVideoImpression(
      buildVideoCompleteTrackingPayload(trackingProductModel),
    )
  }

  function onReviewClick({
    averageRate,
    count,
  }: {
    averageRate: number
    count: number
  }) {
    trackClick(buildReviewClickTrackingPayload({ averageRate, count }))
  }

  return {
    onScrollStart,
    onScrollEnd,
    onSlideImpression,
    onVideoPlay,
    onVideoComplete,
    onReviewClick,
  }
}
